import { isTagIdResponseDTO } from "./TagId";

export interface TagResponseApi {
  tagId: string;
  tagName: string;
}

export let isTagResponseDTO = (
  variable: unknown
): variable is TagResponseApi => {
  return (
    isTagIdResponseDTO(variable) &&
    "tagName" in variable &&
    typeof variable.tagName === "string"
  );
};
